import { render, staticRenderFns } from "./moodle-course-manager.vue?vue&type=template&id=df4b4672&scoped=true"
import script from "./moodle-course-manager.vue?vue&type=script&lang=js"
export * from "./moodle-course-manager.vue?vue&type=script&lang=js"
import style0 from "./moodle-course-manager.vue?vue&type=style&index=0&id=df4b4672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4b4672",
  null
  
)

export default component.exports